const SERVER_ADDR = "https://mal-api.vitalify.asia/"
const ITEMS_PER_PAGE = 8

export default {
  SERVER_ADDR: SERVER_ADDR,
  ITEMS_PER_PAGE: ITEMS_PER_PAGE,
}